<template>
  <div class="golf-office">
    <div :class="contentClass">
      <div class="flex-container">
        <img
          src="/images/bb-logo-icon.svg"
          alt="Business Board"
          class="logo" />
        <div class="login-container">
          <h1 class="login-title">{{ $t('Businessboard.weMovedTitle') }}</h1>
          <div class="login-prompt">
            {{ $t('Businessboard.weMovedDescription') }}
          </div>
          <a
            href="https://portal.businessboard.se"
            class="bb-btn lg solid bb-green-light">
            <span class="text"> Go to Businessboard Portal </span>
            <span
              class="icon"
              alt="arrow right"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import elementLoader from '@/directives/element-loader';
import { mapActions } from 'vuex';

export default {
  name: 'Home-bb',
  components: {},
  directives: {
    elementLoader,
  },
  computed: {
    user() {
      return this.$store.getters['user/user'];
    },
    loggedIn() {
      return this.$store.getters['user/loggedIn'];
    },
    marginClass() {
      return this.loggedIn ? 'menu-margin' : 'no-margin';
    },
    contentClass() {
      return this.loggedIn ? 'golf-office--content' : 'golf-office--content-bg';
    },
    language() {
      return this.$store.getters['businessboard/language'];
    },
    settings() {
      return this.$store.getters['businessboard/settings'];
    },
  },
  methods: {
    ...mapActions('ui', ['toggleActiveLoaders']),
    login() {
      if (
        this.$refs.userName.dataValue.length > 1 &&
        this.$refs.password.dataValue.length > 1
      ) {
        this.$store
          .dispatch('user/login', {
            username: this.$refs.userName.dataValue,
            password: this.$refs.password.dataValue,
          })
          .then(data => {
            if (data) {
              this.$cookies.set('token', data.token, '7d');
              this.$cookies.set('refresh_token', data.refreshToken, '7d');
              if (this.user && !this.user.club && this.user.superUser) {
                this.$store.dispatch('clubs/clubsSelect', null);
              }
              if (this.user.club && this.user.club.id) {
                this.$store.dispatch('businessboard/fetchSettings');
                this.$cookies.remove('language');
                this.$store.dispatch('businessboard/fetchLanguage');
              }
            }
          });
      }
    },
  },
  mounted() {
    this.isLoading = true;
    if (this.loggedIn && this.user.club && this.user.club.id) {
      this.$store.dispatch('businessboard/fetchLanguage');
      this.$store.dispatch('businessboard/fetchSettings').then(() => {
        if (!this.settings || this.settings.businessBoardVersion === 0) {
          this.$router.push({ path: '/businessboard/landing' });
        }
      });
    } else {
      var locale = (navigator.language || navigator.userLanguage).split('-')[0];
      var locales = this.$i18n.availableLocales;
      if (locales.includes(locale)) {
        this.$i18n.locale = locale;
      } else {
        this.$i18n.locale = 'en';
      }
    }
    this.isLoading = false;
  },
};
</script>
<style lang="scss" scoped>
.golf-office {
  flex-grow: 1;
}
$color-green-50: hsla(165, 44%, 92%, 1);
$color-green-100: hsla(165, 44%, 87%, 1);
$color-green-150: hsla(165, 44%, 82%, 1);
$color-green-200: hsla(165, 44%, 77%, 1);
$color-green-250: hsla(165, 44%, 72%, 1);
$color-green-300: hsla(165, 44%, 67%, 1);
$color-green-350: hsla(165, 34%, 62%, 1);
$color-green-400: hsla(165, 34%, 57%, 1);
$color-green-450: hsla(165, 34%, 52%, 1);
$color-green-500: hsla(165, 34%, 47%, 1);
$color-green-550: hsla(165, 44%, 42%, 1);
$color-green-600: hsla(165, 44%, 37%, 1);
$color-green-650: hsla(165, 44%, 32%, 1);
$color-green-700: hsla(172, 44%, 27%, 1);
$color-green-750: hsla(172, 44%, 22%, 1);
$color-green-800: hsla(172, 44%, 17%, 1);
$color-green-850: hsla(172, 44%, 12%, 1);
$color-green-900: hsla(172, 44%, 10%, 1);
.golf-office--content {
  border-radius: 0;
  background-color: color(bb-primary);
  background-image: url('/images/bb-logo-background.svg');
  height: 86vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.golf-office--content-bg {
  @extend .golf-office--content;

  height: 100vh;
}
.flex-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  padding: 1rem 1.5rem;
  gap: 1rem;
  color: white;
  margin-top: 5rem;
  margin: 5rem 2rem 2rem 2rem;
}
.login-title {
  color: white;
  font-size: 56px;
  line-height: 1;
  padding: 0;
  margin: 0;
}
.login-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4rem;
  gap: 1rem;
  border-radius: 8px;
  max-width: 40rem;

  background-color: #0e3746;
}
.login-prompt {
  font-size: 18px;
  color: white;
  line-height: 1.4;
  margin-bottom: 2rem;
}
.bb-btn {
  all: unset;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  justify-items: center;
  padding: 0.75rem 1.5rem;
  background-color: color(green-fog);
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  line-height: 1;
  font-size: 1.25rem;
  font-weight: bold;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: color(bb-primary);
  }
  &:active {
    background-color: color(dark-green-fog);
  }
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(#fff, 20%);
  }
}
.bb-btn {
  all: unset;
  cursor: pointer;
  transition: transform 0.15s ease-in-out, outline 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out, background 0.15s ease-in-out,
    color 0.4s ease-in-out;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: 'Sora', sans-serif;
  color: white;
  font-style: normal;
  font-weight: 500;
  line-height: 1;
  outline: 0px solid transparent;
  user-select: none;
}
.bb-btn * {
  pointer-events: none;
}
.bb-btn:hover {
  text-decoration: none;
}
.bb-btn[dropshadow] {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
.bb-btn:disabled {
  cursor: default;
}
.bb-btn:active:not([disabled]) {
}
.bb-btn.lg {
  font-size: 18px;
  padding: 16px 18px;
  border-radius: 7px;
  gap: 16px;
}
.bb-btn[disabled]:not([data-invalid='false'])[dropshadow] {
  box-shadow: none !important;
}
.bb-btn.lg i {
  font-size: 20px;
}

/* lightgreen solid */
.bb-btn.solid.bb-green-light {
  color: $color-green-800;
  background: $color-green-50;
}
.bb-btn.solid.bb-green-light:hover:not([disabled]) {
  background: $color-green-200;
}
.bb-btn.solid.bb-green-light:focus-visible:not([disabled]) {
  background: $color-green-300;
  box-shadow: 0px 0px 0px 2px #fff, 0px 0px 0px 4px rgba($color-green-800, 75%);
}
.bb-btn.solid.bb-green-light:active:not([disabled]) {
  background: $color-green-300;
}
.bb-btn.solid.bb-green-light:disabled {
  color: color-mix(in srgb, white 60%, transparent);
  background: color-mix(in srgb, $color-green-50 60%, transparent);
}
.bb-btn.solid.bb-green-light .svg-mask {
  background: white;
}
.bb-btn.solid.bb-green-light:active:not([disabled]) .svg-mask {
  background: rgba(white, 70%);
}
.text {
  display: inline-flex;
  text-align: left;
}
.logo {
  width: 80%;
  margin-bottom: 2rem;
}
.icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  max-width: 20px;
  max-height: 20px;
  min-width: 20px;
  min-height: 20px;
  mask-image: url('/images/bb-circle-arrow-right.svg');
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: $color-green-800;
}
</style>
